<template>
  <panel title="生产跟踪" class="mgb10">
    <el-row :gutter="10">
      <el-col :span="16">
        <div class="subtitle">
          近交期
          <span class="float-right grey-shallow" v-if="nearsTotal">
            {{ nearsTotal.productNoQty || 0 }}款
            {{ nearsTotal.productQty || 0 }}件
          </span>
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <vxe-table
              :data="nearsFront"
              border="inner"
              size="small"
              :loading="loading"
              class="border-inner-top"
              :show-header="false"
              auto-resize
              highlight-hover-row
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column field="date" title="时间"></vxe-table-column>
              <vxe-table-column field="quantity" title="数量" width="100px">
                <template v-slot="{ row }">
                  <router-link
                    :to="{
                      name: 'mesWorkOrders',
                      query: { initFilter: row.date },
                    }"
                  >
                    {{ row.productNoQty || 0 }}款 {{ row.productQty || 0 }}件
                  </router-link>
                </template>
              </vxe-table-column>
            </vxe-table>
          </el-col>
          <el-col :span="12">
            <vxe-table
              :data="nearsTail"
              border="inner"
              size="small"
              :loading="loading"
              class="border-inner-top"
              :show-header="false"
              auto-resize
              highlight-hover-row
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column field="date" title="时间"></vxe-table-column>
              <vxe-table-column field="quantity" title="数量" width="100px">
                <template v-slot="{ row }">
                  <router-link
                    :to="{
                      name: 'mesWorkOrders',
                      query: { initFilter: row.date },
                    }"
                  >
                    {{ row.productNoQty }}款 {{ row.productQty }}件
                  </router-link>
                </template>
              </vxe-table-column>
            </vxe-table>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="8">
        <div class="subtitle">
          过交期
          <span class="float-right grey-shallow" v-if="nearsTotal">
            {{ passesTotal.productNoQty || 0 }}款
            {{ passesTotal.productQty || 0 }}件
          </span>
        </div>
        <vxe-table
          :data="passes"
          border="inner"
          size="small"
          :loading="loading"
          class="border-inner-top"
          :show-header="false"
          auto-resize
          highlight-hover-row
          :scroll-y="{ enabled: false }"
        >
          <vxe-table-column field="dateRange" title="时间"></vxe-table-column>
          <vxe-table-column field="quantity" title="数量" width="100px">
            <template v-slot="{ row }">
              <router-link
                :to="{
                  name: 'mesWorkOrders',
                  query: { initFilter: row.dateRange },
                }"
              >
                {{ row.productNoQty || 0 }}款 {{ row.productQty || 0 }}件
              </router-link>
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-col>
    </el-row>
  </panel>
</template>
<script>
import axios from "axios";
import WorkOrder from "@/api/workOrder.js";
export default {
  data() {
    return {
      loading: false,
      nears: [],
      nearsFront: [],
      nearsTail: [],
      nearsTotal: null,
      passes: [],
      passesTotal: null,
    };
  },
  created() {
    const self = this;
    axios
      .all([WorkOrder.nearHandCount(), WorkOrder.overHandCount()])
      .then(function (res) {
        self.nears = res[0].data.filter((d) => d.date !== null);
        self.nearsFront = self.nears.slice(0, 8);
        self.nearsTail = self.nears.slice(8, 16);
        self.nearsTotal = res[0].data.find((d) => d.date == null);

        self.passes = res[1].data.filter((d) => d.dateRange !== "total");
        self.passesTotal = res[1].data.filter((d) => d.dateRange == "total");
      });
  },
};
</script>

<style scoped>
.subtitle {
  font-size: 13px;
  color: #606266;
  margin-bottom: 10px;
  font-weight: bold;
}
</style>